export const baseInputClasses = (hasError: boolean) =>
  `bg-white text-grey-800 border ${
    hasError ? 'border-red' : 'border-grey-200'
  } shadow-sm focus:ring-1 focus:ring-primary-500 focus:border-primary-500  outline-none flex w-full cursor-text w-full block px-4 py-3 rounded-lg transition appearance-none leading-normal`;
